<template>
  <el-dialog title="新建标签组" :close-on-click-modal="false" :visible.sync="modalVisible" width="820px">
    <el-form ref="configForm" :model="configForm" :rules="formRules" label-width="95px">
      <el-form-item label="标签组名称" prop="groupName">
        <el-input v-model="configForm.groupName" placeholder="请输入标签组名称，2-200个字符"></el-input>
      </el-form-item>
    </el-form>

    <div class="config-table">
      <el-form ref="form" label-width="0" inline @submit.native.prevent class="elementui-common-form-styles" v-highlight>
        <el-form-item>
          <el-select v-model="queryForm.gameGroupIds" filterable clearable multiple collapse-tags>
            <el-option v-for="item in GAME_GROUPS" :key="item.id" :label="item.name" :value="item.id"> </el-option>
          </el-select>
        </el-form-item>

        <el-form-item>
          <el-input v-model="queryForm.keyWord" clearable placeholder="请输入标签名称"></el-input>
        </el-form-item>

        <el-button type="primary" @click="queryAction">查询</el-button>
      </el-form>

      <div class="table-results">
        <div class="table" v-loading="tableLoading">
          <el-table
            class="common-el-table-styles"
            ref="table"
            border
            :height="300"
            :data="tableData"
            style="width: 100%"
            @select="onRowSelect"
            @select-all="onRowAllSelect"
          >
            <el-table-column type="selection" width="50"> </el-table-column>
            <el-table-column prop="content" label="标签名称"> </el-table-column>
          </el-table>

          <el-pagination
            style="margin-top: 5px"
            :current-page.sync="pageInfo.page.pageId"
            :page-size="pageInfo.page.pageSize"
            :total="pageInfo.total"
            background
            layout="prev, pager, next"
            @current-change="queryTagsByPage"
          >
          </el-pagination>
        </div>

        <el-table class="result common-el-table-styles" border :height="300" :data="selectedList" style="width: 100%; margin-left: 10px">
          <el-table-column prop="content">
            <template slot="header" slot-scope="scope">
              <span slot="header" :class="scope.a"> 已选({{ selectedList.length }}/{{ max }}) </span>
            </template>
          </el-table-column>

          <el-table-column width="80">
            <template slot="header"> <el-button type="text" @click="removeAll">清空全部</el-button> </template>

            <template slot-scope="{ row }">
              <span class="el-icon-error" @click="onSelectedRowRemove(row)"></span>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>

    <div slot="footer">
      <el-button @click="onCancel">取 消</el-button>
      <el-button type="primary" :disabled="!selectedList.length" :loading="submitLoading" @click="onConfirm">确 定</el-button>
    </div>
  </el-dialog>
</template>
<script>
import { getTagsList, addTagGroup, updateTagGroup } from '@/api/manage.model.js'
import { initPageData, GAME_GROUPS } from '@/data/global-opts'
import { LABEL_TYPES } from '../const'
const PAGE_REQUIRED_OPTS = initPageData([GAME_GROUPS])

export default {
  props: {
    value: {
      type: Boolean
    }
  },
  computed: {
    ...PAGE_REQUIRED_OPTS,
    modalVisible: {
      get() {
        return this.value
      },
      set(v) {
        this.$emit('input', v)
      }
    },
    selectedLabelIds() {
      return this.selectedList.map((l) => l.labelId)
    }
  },
  data() {
    return {
      max: 1000,
      tableLoading: false,
      submitLoading: false,
      tableData: [],
      selectedList: [], // 已选结果
      queryForm: {
        keyWord: '',
        gameGroupIds: []
      },
      configForm: { groupName: '' },
      pageInfo: {
        total: 0,
        page: {
          pageId: 1,
          pageSize: 20
        }
      },
      formRules: {
        groupName: [
          { required: true, message: '请输入标签组名称', trigger: 'blur' },
          { min: 2, max: 200, message: '长度在 2 到 200 个字符', trigger: 'blur' }
        ]
      }
    }
  },

  created() {
    this.queryAction()
  },

  methods: {
    queryAction() {
      this.pageInfo.page.pageId = 1
      this.queryTagsByPage()
    },
    queryTagsByPage() {
      this.tableLoading = true
      const { keyWord, gameGroupIds } = this.queryForm
      const params = {
        ...this.pageInfo.page,
        keyWord,
        labelType: LABEL_TYPES.CONTENT_LABEL
      }
      if (gameGroupIds?.length) {
        params.gameGroupIdStr = gameGroupIds.join(',')
      }

      getTagsList(params).then((data) => {
        if (data) {
          const { list, page_info } = data
          if (list?.length) {
            this.tableData = data.list
            this.calcSelections()
          } else {
            this.tableData = []
          }
          this.pageInfo.total = page_info.total_number
        }

        this.tableLoading = false
      })
    },
    /**
     * @description: 根据已选结果，在分页表格勾选对于的项
     */
    calcSelections() {
      this.$nextTick(() => {
        const currSelected = this.tableData.filter((row) => this.selectedLabelIds.includes(row.labelId))
        currSelected.forEach((row) => {
          this.$refs.table.toggleRowSelection(row, true)
        })
      })
    },

    /**
     * @description: 勾选或取消勾选
     * @param {*} selection
     * @param {*} row
     */
    onRowSelect(selection, row) {
      const index = this.selectedList.findIndex((s) => s.labelId === row.labelId)
      if (index > -1) {
        this.selectedList.splice(index, 1)
      } else {
        this.selectedList.push({ ...row })
        this.calcLimit()
      }
    },
    /**
     * @description: 全选当前分页并排除重复项
     */
    onRowAllSelect(selection) {
      if (selection.length) {
        // 当前页面全选
        selection.forEach((row) => {
          if (!this.selectedLabelIds.includes(row.labelId)) {
            this.selectedList.push({ ...row })
          }
        })
      } else {
        // 取消当前页面全选
        const pageIds = this.tableData.map((row) => row.labelId)
        this.selectedList = this.selectedList.filter((s) => !pageIds.includes(s.labelId))
      }

      this.calcLimit()
    },
    /**
     * @description: 限制最大可选数量
     */
    calcLimit() {
      this.selectedList = this.selectedList.slice(0, this.max)
      this.$refs.table.clearSelection()
      this.calcSelections()
    },
    removeAll() {
      this.selectedList = []
      this.$refs.table.clearSelection()
    },
    /**
     * @description: 删除一条已选
     */
    onSelectedRowRemove(row) {
      if (row) {
        this.selectedList = this.selectedList.filter((l) => l.labelId !== row.labelId)
        this.$nextTick(() => {
          const tableRow = this.tableData.find((r) => r.labelId === row.labelId)
          this.$refs.table.toggleRowSelection(tableRow, false)
        })
      }
    },
    onConfirm() {
      this.$refs.configForm.validate((valid) => {
        if (valid) {
          this.submitLoading = true
          const { id, groupName } = this.configForm
          const params = { groupName: groupName.trim(), labelIds: this.selectedLabelIds.join(',') }
          ;(id ? updateTagGroup({ ...params, groupId: id }) : addTagGroup(params))
            .then((data) => {
              if (data) {
                this.$emit('confirm')
                this.onCancel()
              }
              this.submitLoading = false
            })
            .catch(() => {
              this.submitLoading = false
            })
        }
      })
    },
    onCancel() {
      this.modalVisible = false

      // 清空表单
      this.queryForm = {
        keyWord: '',
        gameGroupIds: []
      }
      this.configForm = { groupName: '' }

      // 重新获取没有参数的数据
      this.queryAction()

      // 清空表格
      this.removeAll()
    },
    /**
     * @description: 编辑时,填充配置信息
     * @return {*}
     */
    fillForm(row) {
      this.configForm = { groupName: row.groupName, id: row.id }
      this.selectedList = row.labels

      // 编辑时再次查询列表, 勾选已选结果
      // this.pageInfo.page.pageId = 1
      // this.queryTagsByPage()
      this.calcSelections()
    }
  }
}
</script>
<style lang="scss" scoped>
.table-results {
  display: flex;
  .table {
    flex-basis: 60%;
  }
  .result {
    flex-basis: 40%;
    .el-icon-error {
      cursor: pointer;
    }
  }
}
</style>
